import {Alert, Linking} from 'react-native';
import X2JS from 'x2js';
import {Dimensions, Platform, StatusBar} from 'react-native';
import logger from './logger';
var parseString = require('xml2js').parseString;
import InterRegular from '../assets/fonts/Inter-Regular.ttf';
import InterBold from '../assets/fonts/Inter-Bold.ttf';
import InterMedium from '../assets/fonts/Inter-Medium.ttf';
import InterSemiBold from '../assets/fonts/Inter-SemiBold.ttf';
import RNFS from '../components/fs';
import {isTablet, isMobile as isWebResponsive} from 'react-device-detect';
import {setPressClose} from '../redux/slices/AslSlice';
//Boolean Variable
export const debug = false;
//color
export const norcatAppColor = '#003e9c';
export const inputFieldColor = '#f9f9f9';
export const loinBackgroundColor = '#f0f0f0';
export const loginQRbuttonColor = '#002b6f';
export const qrBarDisableColor = '#1b2a41';
export const white = '#FFFFFF';
export const buttonBorderColor = '#4A72FF';
export const appBackground = '#e8edff';
export const primaryColor500 = '#003DA5';
export const primaryState800 = '#2D3643';
export const primaryState300 = '#AFBACA';
export const base100 = '#000000';
export const primaryColor400 = '#003DA5';
export const copyRightColor = '#C6C6CA';
export const primaryState500 = '#5E718D';
export const primaryState50 = '#E8EDFF';
export const primaryState700 = '#002668';
export const primaryColor800 = '#001D4E';
export const primaryColor900 = '#001231';
export const primaryColor700 = '#002668';
export const tabSelector = '#4A72FF';
export const drawerListBackgroundColor = '#202020';
export const drawerListIconSelectedColor = '#4A72FF';
export const drawerListIconUnSelectedColor = '#5E718D';
export const drawerListTextSelectedColor = 'white';
export const drawerListTextUnSelectedColor = 'rgba(255,255,255, 0.6)';
export const drawerListSelectedBackgroundColor = '#021F51';
export const drawerHeaderGradientStartColor = '#001D4E';
export const drawerHeaderGradientEndColor = 'transparent';
export const gray = '#AAB3C3';
export const courseDesciptionContainerColor = 'rgb(50,48,55)';
export const courseDetailLowerViewColor = '#BABABA';
export const couurseDetailButtonColor = 'rgb(54,54,54)';
export const moduleCountBGColor = '#494949';
export const courseListBGColor = '#747378';
export const lockedCourseBGColor = '#AEAEAE';
export const coureTitleBGGradientColorUpper = '#003DA6';
export const coureTitleBGGradientColorLower = '#002055';
export const coureListGradientColorLower = '#302E36';
export const coureListGradientColorMiddle = '#4D4C51';
export const coureListGradientColorUpper = '#302E36';
export const moduleListRowBGColor = '#003DA5';
export const downloadViewColor = '#0041A5';
export const courseSerialNumberColor = '#A7A7A7';
export const primaryColor900a = '#1C222B';
export const downloadCourseMiddleBarColor = '#003C94';
export const profileTextBG = '#F3F3F3';
export const listItemBG = '#F3F3F3';
export const appBackgroundWhiteBG = '#FFFFFF';
export const bottomControllEllipseBG = 'rgba(25, 25, 25, 0.8)';
export const ActivityLoaderColor = '#001231';
export const isDesktop = Platform.OS === 'macos' || Platform.OS === 'windows';

/* HOVER */
export const isHoverEnabled =
   isDesktop || (Platform.OS === 'web' && !isWebResponsive) ? true : false;
logger({isHoverEnabled, isWebResponsive});
export const hoverBtnBgColor = isHoverEnabled ? '#001e78' : primaryColor500;
export const BUTTON_HOVER_COLOR = hoverBtnBgColor;
export const BACK_BUTTON_HOVER_COLOR = isHoverEnabled ? '#09111111' : white;
export const WHITE_BUTTON_HOVER_COLOR = BACK_BUTTON_HOVER_COLOR;
export const WHITE_IMG_TINT_COLOR = '#FFF';
export const BACK_ARROW_HOVER_TINT_COLOR = isHoverEnabled ? '#CCC' : white;
export const LIST_HOVER_COLOR = isHoverEnabled ? '#e8e6e6' : listItemBG;
export const HEADER_TAB_HOVER_COLOR = isHoverEnabled
   ? BACK_BUTTON_HOVER_COLOR
   : 'transparent';
export const WHITE_ICON_HOVER_TINT_COLOR = isHoverEnabled ? '#CCC' : white;
export const WHITE_TEXT_HOVER_COLOR = isHoverEnabled ? '#CCC' : white;
export const TabView_HOVER_COLOR = '#033386';
export const DROPDOWN_HOVER_COLOR = '#00F';
export const togglePassword = true;

export const TERM_AND_CONDITIONS =
   'https://www.norcat.org/downloads/TermsConditions.pdf';
export const PRIVACY_POLICY = 'https://norcat.org/downloads/PrivacyPolicy.pdf';

export const isProductionEnv = true;
/*
In case of web development for local machine for production, we have to make these changes as mention below:
1. in utils.js file change isProductionEnv flag with true.
2. In root directory in package.json file.
we have to change dev url to production at line no 17.
 */
export const isNewAPI = true;

// base url
export const BASE_URL = isProductionEnv
   ? 'https://webtraining.norcat.org/Wsvc/ws.asmx/'
   : 'https://dev-webtraining.norcat.org/Svc/ws.asmx/';
// course
export const TRAINING_LIST_BASE_URL = isProductionEnv
   ? 'https://webtraining.norcat.org/Courses/'
   : 'https://dev-webtraining.norcat.org/Courses/';

export const NORCAT_ORG = 'https://www.norcat.org';
export const CONTACT_US = 'https://www.norcat.org/contact-us.html';
export const FORGOT_PASSWORD = 'https://myibt.norcattraining.com';
export const OFFLINE_VIDEO_PATH =
   'https://webtraining.norcat.org/Courses/OfflineDownloads/';
export const OFFLINE_COURSES_BASE_URL = isProductionEnv
   ? 'https://webtraining.norcat.org/Courses/OfflineDownloads/'
   : 'https://dev-webtraining.norcat.org/Courses/OfflineDownloads/';
//  'https://webtraining.norcat.org/Courses/OfflineDownloads/';
export const GET_LOGIN = 'getLogin';
export const GET_USER_PROFILE = 'GetUserProfile';
export const RESET_PASSWORD = 'ResetUserPassword';
export const GET_DASHBOARD_DATA = 'GetUserTrainingEnrolledRecords';
export const GET_BROWSE = 'GetTrainingCatalog';
export const LOGIN_TO_COURSE = isNewAPI ? 'CourseLogin' : 'LoginToCourse';
export const UPDATE_PROFILE = 'UpdateUserProfile';
export const SAVE_TRAINING_PAGE = 'SaveTrainingPage';
export const SUBMIT_FEEDBACK = isNewAPI
   ? 'SubmitFeedbackData'
   : 'SubmitFeedback';
export const UPDATE_TEST_RECORD = isNewAPI
   ? 'SaveTestRecord'
   : 'updateTestRecord';
export const RESET_ACCOUNT = isNewAPI
   ? 'ResetUserAccountData'
   : 'ResetUserAccount';
export const UNLOCK_COURSE = isNewAPI ? 'UnlockTrainingCourse' : 'UnlockCourse';
export const SEND_ACKNOWLEDGEMENT = 'SendAcknowledgementData';
export const GET_ADVERSTISEMENT = 'GetAdvertisementData';
export const TRAINING_IBT_RECORDS = 'GetUserTrainingIBTRecords';
export const TRAINING_OJT_RECORDS = 'GetUserTrainingOJTRecords';
export const TRAINING_THIRDPARTY_RECORDS = 'GetUserTrainingThirdPartyRecords';
export const TRAINING_EXTERNAL_RECORDS = 'GetUserTrainingExternalRecords';
export const TRAINING_ALL_RECORDS = 'GetUserTrainingAllRecords';
export const PAYMENT_PROCESS = 'ProcessPayment';
export const SEND_TEMPRORARY_PASSWORD = 'SendTemporaryPassword';

//String
export const copyRight = `Copyright © ${new Date().getFullYear()} NORCAT All rights reserved`;
export const AccountSignIn = 'Account Sign In';
export const ResetPassword = 'Reset Password';
export const ResettingPassword = 'Resetting password';
export const CurrentPassword = 'Current Password';
export const NewPassword = 'New Password';
export const ConfirmPassword = 'Confirm Password';
export const SignInLoader = 'Signing-In Account';
export const CurrentPasswordValidation = 'Please enter current password.';
export const NewPasswordValidation = 'Please enter new password.';
export const PasswordMatchValidation =
   'New password & confirm password do not match.';
export const PasswordResetError = 'Unable to reset password';
export const LoginError = 'Unable to log in';
export const Reset = 'Reset';
export const RequestingPassword = 'Requesting Temporary Password';
export const SignIn = 'Sign In';
export const QrSignIn = 'QR Sign In';
export const rememberAccount = 'Remember Account';
export const forgotPassword = 'Forgot Password';
export const DoNotHaveAnAccount = "Don't have an account ?";
export const AUTHDATA = 'authData';
export const QrBarcodeSignIn = 'QR/Barcode Sign In';
export const ALLCOURSE = 1;
export const RECENT = 2;
export const INSESSION = 3;
export const HIDELEGACY = 4;
export const REFRESH_DASHBOARD = 5;
export const VALID = 1;
export const All = 2;
export const DASHBOARD = 1;
export const MYTRAINING = 2;
export const PROFILE = 3;
export const BROUS = 4;
export const FREE_COURSE = -1;
export const COURSE_STATUS_0_ENR = '0 -ENR';
export const COURSE_STATUS_1_SES = '1 -SES';
export const IBTRecords = 'NORCAT Records';
export const ExternalRecords = 'External Records';
export const ThirdPartyRecords = 'Third Party Records';
export const TrainingOJTRecords = 'OJT Records';
export const TrainingAllRecords = 'All Records';
export const logoutMessage =
   'Do you want to sign out of your current account? You can easily sign back in any time.';
export const accountSignOut = 'Account Sign-Out';
export const contactUs = 'Contact Us';
export const norcatOrg = 'NORCAT.org';
export const cancel = 'Cancel';
export const confirm = 'Confirm';
export const scanBarcode = 'Scan Barcode';
export const scanQRcode = 'Scan QR Code';
export const loginErrorMessage = 'Please verify your login credentials.';
export const VIEWALL = 'Viewing All Training Records';
export const VIEWVALID = 'Viewing Valid Training Records';
export const forgotPasswordSubTitle =
   'Please enter e-mail, first name and last name. A temporary password will be sent to e-mail address.';
export const pwdValidation =
   'New password must contain the following requirements. At least eight characters, one number, one uppercase letter and one lowercase letter.';

//preference Key
export const secure_checkout = 'Secure Checkout';
export const USER_PROFILE = 'Please Verify: User Profile';

export const REMEMBER_ACCOUNT = 'remember_Account';
export const ACCOUNT_EMAIL = 'emailAccount';
export const ACCOUNT_PASSWORD = 'accountPassword';
export const COURSE_ROOT_ITEM = 'CourseRootItem';
export const Attestation = 'isAttested';
export const LastAttestation = 'lastAttested';
export const DownloadMode = 'download';
export const TutorialShown = 'tutorialShown';
export const rotateDeviceMsg = `Please rotate your device to ${
   isTablet ? 'Landscape' : 'Portrait'
}`;
export const rotatePlayerScreenMsg = `Please rotate your device to ${
   isTablet ? 'Landscape' : 'Landscape'
} mode.`;
// checks platform
export const isWeb = Platform.OS === 'web';
export const isWindows = Platform.OS === 'windows';
export const isMacOS = Platform.OS === 'macos';
export const isAndroid = Platform.OS === 'android';
export const isiOS = Platform.OS === 'ios';
export const isMobile = Platform.OS === 'android' || Platform.OS === 'ios';
const userAgent = window.navigator.userAgent;
export const isMobileWeb =
   isWeb && (userAgent.includes('iPhone OS') || userAgent.includes('Android'));
export const FONT_FAMILY_REGULAR =
   Platform.OS !== 'macos'
      ? isWeb
         ? InterRegular
         : 'Inter-Regular'
      : 'Helvetica Neue';
export const FONT_FAMILY_BOLD =
   Platform.OS !== 'macos'
      ? isWeb
         ? InterBold
         : 'Inter-Bold'
      : 'Helvetica Neue Bold';
export const FONT_FAMILY_SEMI_BOLD =
   Platform.OS !== 'macos'
      ? isWeb
         ? InterSemiBold
         : 'Inter-SemiBold'
      : 'Helvetica Neue';
export const FONT_FAMILY_MEDIUM =
   Platform.OS !== 'macos'
      ? isWeb
         ? InterMedium
         : 'Inter-Medium'
      : 'Helvetica Neue Medium';

export function getNavBarHeight() {
   const {height, width} = Dimensions.get('window');
   let navBarHeight = 0;
   if (Platform.OS === 'android') {
      navBarHeight = 56; // default android navigation bar height
   } else if (Platform.OS === 'ios') {
      if (height === 812 || width === 812) {
         navBarHeight = 88; // iPhone X navigation bar height
      } else {
         navBarHeight = 64; // default iOS navigation bar height
      }
   }
   return navBarHeight;
}

export function getStatusBarHeight() {
   const statusBarHeight =
      Platform.OS === 'ios'
         ? Platform.isPad
            ? 24
            : 20
         : StatusBar.currentHeight;
   return statusBarHeight;
}

export function redirectToBrowser({url}) {
   logger(`URL:: ${url}`);
   Linking.openURL(url);
}

export function overAllPercent(data) {
   var wheelPercentage = 0;
   try {
      const parsedData = JSON.stringify(data);
      const parseData = JSON.parse(parsedData);
      var pagesCompleted = 0;
      var pagesTotal = 0;
      var enrolledCoursesList = null;
      if (isNewAPI) {
         enrolledCoursesList = parseData;
      } else {
         enrolledCoursesList = parseData.enrolledCourses;
      }
      enrolledCoursesList.forEach(ec => {
         pagesCompleted += parseInt(ec.pageNumber);
         pagesTotal += parseInt(ec.pageCount);
      });
      var percentage = 0;
      if (pagesTotal === 0) {
         percentage = 0;
      } else {
         percentage = pagesCompleted / pagesTotal;
      }

      wheelPercentage = Math.ceil(percentage * 100);

      //Percentage handling
      if (wheelPercentage > 100) {
         wheelPercentage = 100;
      }
      return !isNaN(wheelPercentage) ? wheelPercentage : 0;
   } catch (e) {
      return wheelPercentage;
   }
}

export function enrolledCoursesLength(data) {
   var eCourseLen = 0;
   try {
      const parsedData = JSON.stringify(data);
      const parseData = JSON.parse(parsedData);
      const enrolledCoursesList = parseData.enrolledCourses;
      eCourseLen = enrolledCoursesList.length;
      return eCourseLen;
   } catch (e) {
      logger(`Exception::  ${e.message}}`);
      return eCourseLen;
   }
}

export function RijindaelDecoction({dcrText}) {
   try {
      var CryptoJS = require('crypto-js');
      var text = dcrText;
      const indexOfPipe = text.indexOf('|');

      const ivStartIndex = indexOfPipe + 1;
      const ivEndIndex = indexOfPipe + 24 + 1;
      const iv = text.substring(ivStartIndex, ivEndIndex);

      const keyStartIndex = indexOfPipe + 25;
      const keyEndIndex = indexOfPipe + 44 + 25;
      var key = text.substring(keyStartIndex, keyEndIndex);

      const temData = text.substring(indexOfPipe, indexOfPipe + 69);

      var rawData = text.replace(temData, '');

      var decrypted = CryptoJS.AES.decrypt(
         {ciphertext: CryptoJS.enc.Base64.parse(rawData)},
         CryptoJS.enc.Base64.parse(key),
         {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7,
            iv: CryptoJS.enc.Base64.parse(iv),
         },
      );
      const result = decrypted
         .toString(
            isWeb || isMacOS ? CryptoJS.enc.Utf16LE : CryptoJS.enc.Utf8,
         )
         .replace(isMacOS ? /\u0019/g : '\u0019', "'");
      let sR = '';
      for (let i = 0; i < result.length; i++) {
         if (result.charCodeAt(i) !== 0) {
            sR += result.charAt(i);
         }
      }
      const rectifyData = parseSpecialChar(sR);
      logger('Rjindael:::::', rectifyData);
      const parsJson = toJson(rectifyData);
      return {responseCode: 1, data: parsJson};
   } catch (e) {
      logger(e);
      return {responseCode: 0, data: e.message};
   }
}

function toJson(xmlData) {
   var json_value;
   if (Platform.OS === 'web') {
      // logger(xmlData);
      let options = {
         explicitArray: false,
      };
      parseString(xmlData, options, function (_err, result) {
         // logger('Rjindael', result);
         if (result) {
            json_value = JSON.stringify(result);
         }
      });
      // var json_value = new XMLParser().parseFromString(xmlData);
   } else {
      var x2js = new X2JS();
      json_value = JSON.stringify(x2js.xml2js(xmlData));
   }
   return json_value;
}

export function moduleComplitedPercentage(item) {
   var mPrecent = 0;
   try {
      const modules = parseInt(item.coursemodulecount);
      const completedtmodule = parseInt(item.modulesCompleted);
      mPrecent = completedtmodule === 0 ? 0 : completedtmodule / modules;
      mPrecent = mPrecent * 100;
      return mPrecent;
   } catch (e) {
      mPrecent = 0;
      return mPrecent;
   }
}

export function module_Level(item) {
   return (
      item.coursemodulecount +
      ' ' +
      (item.coursemodulecount === '1' ? ' Module' : ' Modules')
   );
}

export function hour_Level(item) {
   const hour = Math.round(parseInt(item.courseduration) / 60);
   const hourLevel = hour + ' ' + (hour === 1 ? 'Hour' : 'Hours');
   return hourLevel;
}

export function trainingValidity_Level(item) {
   var friendlyValidity = '';

   const courseValidity = parseInt(item.coursevalidity) / 12;

   if (courseValidity == 50) {
      friendlyValidity = ' Does not expire';
   } else if (courseValidity > 1) {
      friendlyValidity = ' Valid for ' + courseValidity + ' years';
   } else if (courseValidity == 0) {
      friendlyValidity = '';
   } else {
      friendlyValidity = ' Valid for ' + courseValidity + ' year';
   }

   return friendlyValidity;
}

export function trCurrentProgressLevel(item) {
   const pn = parseInt(item.pageNumber);
   const pc = parseInt(item.pageCount);
   var currentProgress = 0;

   if (pc == 0) {
      return (currentProgress = 0 + '%');
   } else if (pn > pc) {
      return (currentProgress = '100%');
   } else {
      return (currentProgress = (pn / pc) * 100 + '%');
   }
}

export function myIBTAlert({title, message, pCallBack}) {
   Alert.alert(title, message, [
      pCallBack === 'undefined'
         ? null
         : {text: 'OK', onPress: () => pCallBack()},
   ]);
}

export function getVideoPath(courseNameID, SlideVideoClipString) {
   /*const isIOS = Platform.OS === 'ios';
  const isAndroid = Platform.OS === 'android';
  const isMobilePlatform = isIOS || isAndroid;
  if (isMobilePlatform) {
    return 'https://webtraining.norcat.org/Courses/';
  } else {
    return '';
  }*/
   return (
      'https://webtraining.norcat.org/Courses/' +
      courseNameID +
      SlideVideoClipString
   );
}
export function getReviewQuestionAnswerData(data, moduleIndex, questionId) {
   logger({data, moduleIndex, questionId});
   const arrQuestionAnswerData =
      data[moduleIndex].CourseTestItem.CourseTestItem;

   // Below Lines till before `for` loop is for debugging, above two lines was the original code
   // logger('utils:', data, moduleIndex);
   // let index = moduleIndex;
   // if (data?.length >= moduleIndex) {
   //    index = data.length - 1;
   // }
   // const arrQuestionAnswerData = data[index].CourseTestItem.CourseTestItem;
   if (Array.isArray(arrQuestionAnswerData)) {
      for (let index = 0; index < arrQuestionAnswerData.length; index++) {
         const element = arrQuestionAnswerData[index];
         if (questionId == element.TestItemID) {
            return element;
         }
      }
   } else {
      return arrQuestionAnswerData;
   }
}

export function getFinalQuestionAnswerData(
   data,
   allQuestions,
   moduleIndex,
   questionCount,
) {
   const arrFinalQuestionsAnswer = [];
   if (allQuestions) {
      for (let i = 0; i < data.length; i++) {
         const courseItem = data[i].CourseTestItem.CourseTestItem;
         for (let x = 0; x < courseItem.length; x++) {
            const element = courseItem[x];
            arrFinalQuestionsAnswer.push(element);
         }
      }
      const finalQuesAnsList = trimGeneratedList(
         arrFinalQuestionsAnswer,
         questionCount,
      );
      return finalQuesAnsList;
   } else {
      const arrQuestionAnswerData =
         data[moduleIndex].CourseTestItem.CourseTestItem;
      if (Array.isArray(arrQuestionAnswerData)) {
         for (let i = 0; i < arrQuestionAnswerData.length; i++) {
            const element = arrQuestionAnswerData[i];
            arrFinalQuestionsAnswer.push(element);
         }
      } else {
         arrFinalQuestionsAnswer.push(arrQuestionAnswerData);
      }

      const finalQuesAnsList = trimGeneratedList(
         arrFinalQuestionsAnswer,
         questionCount,
      );

      return finalQuesAnsList;
   }
}
export function trimGeneratedList(generatedCourseTestItems, questionCount) {
   logger('before::', generatedCourseTestItems);
   logger('QUESTION COUNT:::=>', questionCount);
   generatedCourseTestItems.sort(() => Math.random() - 0.5);
   logger('list::', generatedCourseTestItems);

   generatedCourseTestItems.sort(x => (x.isMandatory ? 0 : 1));
   var modifiedQList = generatedCourseTestItems;
   logger('withMandatory::', generatedCourseTestItems);
   if (generatedCourseTestItems.length > questionCount) {
      const startIndex = generatedCourseTestItems.length - questionCount;
      // endIndex = generatedCourseTestItems.length;
      modifiedQList = generatedCourseTestItems.slice(startIndex);
   }
   return modifiedQList;
}

export function calculatePassingPercentage(totalQuestions, correctAnswer) {
   const percentage = (correctAnswer / totalQuestions) * 100;
   return percentage;
}

export function getAllSmallAlphabets(index) {
   const arrAllChars = Array.from({length: 26}, (_, i) =>
      String.fromCharCode('a'.charCodeAt(0) + i),
   );
   return arrAllChars[index];
}

export function getCourseProgressLevel(item, width) {
   /**
   {
     To use this function for showing linear progress, the horizontal margin of the view
     must be considered,
     getCourseProgressLevel(item, full width - margin * 2 );

     To show progress on the tablet version use like below
     getCourseProgressLevel(item, width * 0.4 - 16 * 2 );


     To show progress on the mobile version use like below
     getCourseProgressLevel(item, width - 16 * 2);
   }
   */
   const pn = parseInt(item.pageNumber);
   const pc = parseInt(item.pageCount);
   var currentProgress = 0;

   if (pc == 0) {
      currentProgress = 0;
   } else if (pn > pc) {
      currentProgress = 100;
   } else {
      currentProgress = (pn / pc) * 100;
   }
   logger('p: ' + currentProgress, 'pc: ' + pc, ' pn: ' + pn, ' w: ' + width);
   logger('percentage', currentProgress.toString() + '%');
   logger('calculated width', (currentProgress / 100) * width + '%');
   return (currentProgress / 100) * width;
}

export function isDownloadAllowed() {
   //Here we can add some other condition for download access
   if (Platform.OS === 'macos' || Platform.OS === 'windows') {
      return true;
   }
   return false;
}

// export function getFullName(authData) {
//   return authData.ACMEmployeeLastName + ' ' + authData.ACMEmployeeFirstName;
// }

export function getFullName(authData) {
   if (isNewAPI) {
      return authData.LastName + ', ' + authData.FirstName;
   } else {
      return (
         authData.ACMEmployeeLastName + ', ' + authData.ACMEmployeeFirstName
      );
   }
}

export function getFirstName(authData) {
   if (isNewAPI) {
      return authData.FirstName;
   } else {
      return authData.ACMEmployeeFirstName;
   }
}

export function getEmployeeKey(authData) {
   if (isNewAPI) {
      return authData.EmployeeKey;
   } else {
      return authData.ACMEmployeeKey;
   }
}

export function getLastName(authData) {
   if (isNewAPI) {
      return authData.LastName;
   } else {
      return authData.ACMEmployeeLastName;
   }
}

export function getFistNameAndLastName(authData) {
   if (isNewAPI) {
      return authData.FirstName + ' ' + authData.LastName;
   } else {
      return authData.ACMEmployeeFirstName + ' ' + authData.ACMEmployeeLastName;
   }
}

export function getDob(authData) {
   if (isNewAPI) {
      return authData.DateOfBirth;
   } else {
      return authData.DoB;
   }
}

export function getEmail(authData) {
   if (isNewAPI) {
      return authData.EmailAddress;
   } else {
      return authData.ACMEmployeeEmail;
   }
}

export const validatePassword = password => {
   const pwdRegex =
      /^(?=.*[0-9])(?=.*[a-z])(?=.*[A-Z])[a-zA-Z0-9!@#$%^&*]{8,}$/;
   if (!pwdRegex.test(password)) {
      return false;
   }

   return true;
};

export const validateEmail = email => {
   const emailRegex = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;
   if (!emailRegex.test(email)) {
      return false;
   }

   return true;
};

export function getProfileImage(authData) {
   // if (isNewAPI) {
   //    return authData.Picture;
   // } else {
   //    return authData.Picture;
   // }
   return authData.Picture;
}

export function getPhoneNumaber(authData) {
   if (isNewAPI) {
      return decodeURIComponent(authData.PhoneNumber);
   } else {
      return decodeURIComponent(authData.ACMEmployeePhone);
   }
}

export const attestationText =
   'NORCAT, we take health and safety compliance seriously, and our e-learning courses are designed, implemented, and monitored with the utmost rigor to ensure all standards are met. As such, it is a requirement that all assigned courses are fully completed by the NORCAT assigned user ONLY. Collaboration or having someone else complete the course on your behalf is strictly prohibited and will not be tolerated. \n\nAny such violation will result in immediate failure of the course and revocation of your certification (if applicable). Moreover, it can lead to your immediate removal from the worksite and stricter enforcement from your company as per their policies and Ministry of Labour regulations. The integrity of our e-learning courses is critical to the health, safety, and success of all workers and companies involved, and under no circumstance will any violation be tolerated. By clicking “Accept”, you are acknowledging that you are the person registered with NORCAT for this training and you are the person who is completing the knowledge component and skill testing questions. A digital record of this attestation will be logged for this session.\n\nChanges you request to your personal information may take up to 24 hours to take effect or on weekends up to 72 hours. Please do not update your information more than once after submitting changes.';

export const AcceptMEssage =
   'By clicking “Accept” you are acknowledging that the personal information is correct. Any changes made to the following information will be reflected in your account within 5-7 business days.';

export function getNorcatId(authData) {
   if (isNewAPI) {
      return authData.NORCAT_ID;
   } else {
      return authData.OCGCTNorcat_ID;
   }
}

export function getQRCode(authData) {
   if (isNewAPI) {
      return authData.QRCode;
   } else {
      return authData.QRID;
   }
}

export function getLoginToCourseParams(courseData, authData) {
   let loginToCourseParams = {};
   if (isNewAPI) {
      loginToCourseParams = {
         theData: JSON.stringify({
            EmployeeKey: authData.EmployeeKey,
            UserKey: courseData.userKey,
            UserID: courseData.loginid,
            Password: courseData.pid,
            CourseKey: courseData.courseKey,
            CourseID: courseData.courseNameID,
            CurrentStatus: courseData.courseStatus,
         }),
      };
   } else {
      loginToCourseParams = {
         CN: courseData.courseNameID,
         CLID: courseData.loginid,
         CPID: courseData.pid,
      };
   }
   return loginToCourseParams;
}
export function getFinalTestParams(
   scratchPadRecord,
   authData,
   moduleIndex,
   questionAsked,
   qCorrect,
   passCode,
   qData,
   CourseSaveCount,
) {
   let submitTestParams = {};
   if (isNewAPI) {
      submitTestParams = {
         theData: JSON.stringify({
            EmployeeKey: authData.EmployeeKey,
            UserKey: scratchPadRecord[moduleIndex].UserKey,
            UserID: scratchPadRecord[moduleIndex].UserID,
            CourseID: scratchPadRecord[moduleIndex].CourseID,
            CourseModuleCount: scratchPadRecord[moduleIndex].CourseModuleCount,
            ModuleNumber: scratchPadRecord[moduleIndex].ModuleNumber,
            PageNumber: scratchPadRecord[moduleIndex].ModulePageNumber,
            ScratchKey: scratchPadRecord[moduleIndex].ScratchPadKey,
            TestCode: passCode,
            QuestionData: qData,
            CourseSaveCount: CourseSaveCount,
         }),
      };
   } else {
      submitTestParams = {
         scratchKey: scratchPadRecord[moduleIndex].ScratchPadKey,
         moduleID: moduleIndex,
         qAsked: questionAsked,
         qCorrect: qCorrect,
         passCode: passCode,
         qData: qData,
      };
   }
   return submitTestParams;
}

export function submitFeedbackParams(courseData, authData, feedback) {
   let reqParms = {};
   if (isNewAPI) {
      reqParms = {
         theData: JSON.stringify({
            EmployeeKey: authData.EmployeeKey,
            NorcatID: authData.NORCAT_ID,
            FirstName: authData.FirstName,
            LastName: authData.LastName,
            Email: authData.EmailAddress,
            CompanyName: authData.CompanyName,
            CourseName: courseData.courseName,
            FeedbackMessage: feedback,
            ModuleNumber: courseData.moduleId,
            PageNumber: courseData.modulePageNumber,
         }),
      };
   } else {
      reqParms = {
         norcatid: courseData.norcatid,
         courseName: courseData.courseName,
         module: courseData.moduleId,
         slide: courseData.slid,
         feedback: feedback,
      };
   }
   return reqParms;
}

export function alertWithCallBack({title, message, callBack}) {
   Alert.alert(title, message, [
      {
         text: 'OK',
         onPress: () => {
            callBack();
         },
      },
   ]);
}

export const webLandscapeViewStyle = {
   transform: 'rotate(-90deg)',
   transformOrigin: 'left top',
   width: '100vh',
   height: '100vw',
   overflowX: 'hidden',
   position: 'absolute',
   top: '100vh',
   left: 0,
};
export const colorPrimaryError25 = '#FFF5F4';
export const colorPrimaryError300 = '#FF7A72';
export const colorPrimaryError600 = '#E92215';

export const timeDiff = (from, to = Date.now(), type = 'm') => {
   const startTime = new Date(parseInt(from));
   const endTime = new Date(parseInt(to));
   const difference = endTime.getTime() - startTime.getTime(); // This will give difference in milliseconds
   let result =
      type === 'm'
         ? Math.round(difference / 60000)
         : type === 'h'
         ? Math.round((difference / 60000) * 60)
         : difference;
   return result;
};

export const checkFileExists = async filename => {
   try {
      const documentDirectory = RNFS.DocumentDirectoryPath;
      const filePath = `${documentDirectory}/Norcat/${filename}`;
      const fileExists = await RNFS.exists(filePath);
      logger('mac video path:' + fileExists + filePath);
      return fileExists;
   } catch (error) {
      logger('Error checking file:', error);
      return false;
   }
};

export const checkManifestFileExists = async folderName => {
   try {
      const documentDirectory = RNFS.DocumentDirectoryPath;
      const filePath = `${documentDirectory}/Norcat/${folderName}/${'manifest.xc'}`;
      const fileExists = await RNFS.exists(filePath);
      logger('manifest exists:' + fileExists + filePath);
      return fileExists;
   } catch (error) {
      logger('Error checking manifest file:', error);
      return false;
   }
};

export const isFoldeExistsAtDocumentDirecotory = async folderName => {
   try {
      // Get the document directory path
      const documentDirectoryPath = RNFS.DocumentDirectoryPath;

      // Create the full path for the folder
      const folderPath = `${documentDirectoryPath}/${folderName}`;

      // Check if the folder already exists
      const folderExists = await RNFS.exists(folderPath);

      if (!folderExists) {
         // If the folder doesn't exist, create it
         await RNFS.mkdir(folderPath);
         return true; // Folder was created successfully
      }

      return true; // Folder already exists
   } catch (error) {
      console.error('Error creating folder:', error);
      return false; // Folder creation failed
   }
};
export const currencyConverter = (value, currency, languageCode) => {
   return new Intl.NumberFormat(languageCode, {
      style: 'currency',
      currency,
   }).format(value);
};
export function parseSpecialChar(stringData) {
   try {
      const byteArray = new TextEncoder().encode(stringData);
      const utf8DecodedString = new TextDecoder('utf-8').decode(byteArray);
      var rectifyData = utf8DecodedString
         .replace(new RegExp('\u0019', 'g'), "'")
         .replace(new RegExp('\u0013', 'g'), '-');
      return rectifyData.replace(/[\u0000-\u001F]/g, '');
      // Now utf8DecodedString contains the decoded string
      logger(utf8DecodedString);
   } catch (error) {
      return stringData;
   }
}
export function setWebNavTitle(navigation, title = 'Dashboard') {
   navigation.setOptions({
      title,
   });
}
export function alertHandler(
   dispatch,
   setResponseAlertData,
   message,
   callbackType = 'GO_BACK',
) {
   if (isWeb) {
      dispatch(
         setResponseAlertData({
            showAlert: true,
            title: 'Alert!',
            message,
            callbackType,
         }),
      );
   } else {
      alert(message);
   }
}
export function rectifyBooleanString(flag) {
   var rectifiedFlag = false;
   if (typeof flag === 'string') {
      rectifiedFlag = flag === 'true' ? true : false;
   } else {
      rectifiedFlag = flag;
   }
   return rectifiedFlag;
}

export function aslCloseHandler(dispatch) {
   dispatch(setPressClose(true));
   setTimeout(() => {
      dispatch(setPressClose(false));
   }, 100);
   return;
}

// This method is used to get path of downloaded medias/ASL medias from document directory.
export function getASLMediaPath(mediaType, CourseID, urlString) {
   const filename = urlString.split('/').pop();
   const documentDirectory = RNFS.DocumentDirectoryPath;
   const basePath = isMacOS
      ? 'file://' + `${documentDirectory}/Norcat/${CourseID}/`
      : `${documentDirectory}/Norcat/${CourseID}/`;
   let path = `${basePath}videos/${CourseID}.mp4`;

   switch (mediaType) {
      case 'video':
         path = `${basePath}videos/${filename}`;
         break;
      case 'audio':
         path = `${basePath}audio/${filename}`;
         break;
      default:
         path = '';
         break;
   }

   return path;
}

export function getASLMacServerPath(mediaType, CourseID) {
   const documentDirectory = RNFS.DocumentDirectoryPath;
   const basePath = `${documentDirectory}/Norcat/${CourseID}/`;
   let path = ``;

   switch (mediaType) {
      case 'video':
         path = `${basePath}videos`;
         break;
      case 'audio':
         path = `${basePath}audio`;
         break;
      default:
         path = '';
         break;
   }

   return path;
}

export function getMediaPath(mediaType, CourseID, urlString) {
   let path = TRAINING_LIST_BASE_URL + CourseID + urlString;
   if (isDesktop) {
      path = getASLMediaPath(mediaType, CourseID, urlString);
   }
   return path;
}
